import type { IMasterDataDistributionCenterRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataDistributionCenterDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataDistributionCenterUseCase {
  private readonly repository: IMasterDataDistributionCenterRepository;

  constructor(repository: IMasterDataDistributionCenterRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataDistributionCenterDTO) {
    return this.repository.updateDistributionCenter(params);
  }
}
